<template>
  <div class="shop-header">
    <div v-if="goBack" class="d-flex">
      <div>
        <button @click="navigate('go-back')">
          <font-awesome-icon icon="fa-solid fa-arrow-left" size="lg" />
        </button>
      </div>
      <CartIcon />
    </div>
    <div class="d-flex" v-else>
      <button @click="navigate('/')">
        <font-awesome-icon icon="fa-solid fa-home" size="lg" />
      </button>
      <span class="font-weight-bold mb-0">{{ text }}</span>
    </div>
  </div>
</template>

<script>
import CartIcon from "@/components/CartIcon";
export default {
  props: {
    goBack: {
      type: Boolean,
    },
    text: {
      type: String,
      default: "",
    },
  },
  components: {
    CartIcon,
  },
  methods: {
    navigate(type){
      if (type === 'go-back') {
        this.$router.back();
      }else {
        this.$router.push('/')
      }
    }
  }
};
</script>

<style scoped>
.d-flex {
  align-items: center;
  gap: 10px;
}
</style>

<style>
.shop-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  display: flex;
  align-items: center;
}

.shop-header button {
  background: none;
  border: none;
  border-radius: 999px;
  padding: 10px;
  color: #666;
  outline: none;
}

.shop-header button:hover {
  background: #eee !important;
  cursor: pointer;
}
</style>
